import React, { useCallback, useRef } from "react";
import { Field, useField } from "formik";
import { FormControl, FormLabel, FormErrorMessage } from "@chakra-ui/react";
import Select from "react-select";
import { MdKeyboardArrowDown } from "react-icons/md";

export const CustomMultiSelectWField = ({
  fieldName,
  label,
  placeholder,
  visible,
  getOptionLabel,
  getOptionValue,
  autoload,
  isLoading,
  options,
  onChange,
  onFocus,
  mt,
  values,
  width,
  separatorFalse,
  placeholderColor,
  isDisabled,
  todos,
  limitado,
}) => {
  const formControlRef = useRef(null);

  const handleScrollToBottom = useCallback(() => {
    if (formControlRef.current) {
      formControlRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      if (limitado) {
        setTimeout(() => {
          formControlRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 300);
      }
    }
  }, [limitado]);

  const normalizeText = (text) =>
    text
      ?.toString()
      ?.normalize("NFD")
      ?.replace(/[\u0300-\u036f]/g, "")
      ?.replace(/[^a-zA-Z0-9\s]/g, "")
      ?.toLowerCase();

  const customStyles = (form, fieldName) => ({
    placeholder: (provided) => ({
      ...provided,
      color: placeholderColor ? "#1A202C" : "#A0AEC0",
    }),

    menu: (provided) => ({
      ...provided,
      width: width ? width : "100%",
    }),

    indicatorSeparator: (provided) => ({
      ...provided,
      display: separatorFalse ? "none" : "block",
    }),

    control: (provided, state) => ({
      ...provided,
      opacity: isDisabled && "0.7 !important",
      paddingInlineStart: "var(--chakra-space-1)",
      paddingInlineEnd: "0.5rem",
      width: width ? width : "100%",
      minWidth: "0px",
      outline: "2px solid transparent",
      outlineOffset: "2px",
      transitionProperty: "var(--chakra-transition-property-common)",
      transitionDuration: "var(--chakra-transition-duration-normal)",
      background: isDisabled ? "#dbdbdb" : "inherit",
      lineHeight: "var(--chakra-lineHeights-normal)",
      fontSize: "var(--chakra-fontSizes-md)",
      minHeight: "42px",
      height: "auto",
      borderRadius: "var(--chakra-radii-md)",
      borderWidth: "1px",
      borderColor: state.isFocused
        ? "var(--chakra-colors-blue-300)"
        : form.errors[fieldName] && form.touched[fieldName]
          ? "var(--chakra-colors-red-500)"
          : isDisabled
            ? "#666"
            : "var(--chakra-colors-gray-200)",
      "&:hover": {
        borderColor:
          form.errors[fieldName] && form.touched[fieldName]
            ? ""
            : "var(--chakra-colors-gray-300)",
      },
      backgroundColor: "var(--chakra-colors-white)",
    }),

    valueContainer: (provided) => ({
      ...provided,
      padding: "2px 8px",
      flexWrap: "wrap",
      maxHeight: "100px",
      overflowY: "auto",

      scrollbarWidth: "thin",
      "&::-webkit-scrollbar": {
        width: "6px",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#CBD5E0",
        borderRadius: "4px",
      },
    }),

    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
  });

  const [, , helpers] = useField(fieldName);

  const handleSelectChange = (selectedOption) => {
    let formattedValue;

    if (todos) {
      if (!selectedOption || selectedOption.length === 0) {
        formattedValue = [];
        helpers.setValue([]);
      } else {
        const hasAll = selectedOption.some((opt) => opt.id === "");

        if (hasAll) {
          formattedValue = [[{ id: "", descricao: "Todos" }]];
          helpers.setValue(formattedValue);
        } else {
          formattedValue = [selectedOption];
          helpers.setValue(formattedValue);
        }
      }
    } else {
      if (selectedOption && selectedOption.length > 0) {
        formattedValue = [selectedOption];
        helpers.setValue(formattedValue);
      } else {
        formattedValue = [];
        helpers.setValue([]);
      }
    }

    onChange?.(formattedValue);
  };
  const DropdownIndicator = () => {
    return <MdKeyboardArrowDown color="#1A202C" size={18} />;
  };

  return (
    <Field name={fieldName}>
      {({ field, form }) => (
        <FormControl
          name={fieldName}
          isInvalid={form.errors[fieldName] && form.touched[fieldName]}
          id={fieldName}
          mt={mt ? mt : "0px"}
          onClick={handleScrollToBottom}
          ref={formControlRef}
        >
          <FormLabel
            color="#5F6377"
            fontWeight="500"
            whiteSpace={"nowrap"}
            fontSize="14px"
            lineHeight="19.6px"
            htmlFor={fieldName}
          >
            {label}
          </FormLabel>
          {visible ? (
            <Select
              id={`select-${fieldName}`}
              getOptionLabel={getOptionLabel}
              getOptionValue={getOptionValue}
              loadingMessage={() => "Carregando..."}
              noOptionsMessage={() => "Sem opções"}
              isLoading={isLoading}
              options={options}
              isMulti
              placeholder={placeholder}
              value={values || ""}
              onChange={(selectedOption) => {
                handleSelectChange(selectedOption);
              }}
              onFocus={onFocus}
              styles={customStyles(form, fieldName)}
              components={{ DropdownIndicator: DropdownIndicator }}
              isDisabled={isDisabled}
              filterOption={(option, inputValue) => {
                const input = normalizeText(inputValue || "");

                if (option?.data?.searchLabel) {
                  return normalizeText(option?.data?.searchLabel)?.includes(
                    input,
                  );
                }

                const label =
                  option?.data?.nome ||
                  option?.data?.label ||
                  option?.label ||
                  "";
                return normalizeText(label)?.includes(input);
              }}
            />
          ) : (
            ""
          )}

          <FormErrorMessage>{form.errors[fieldName]}</FormErrorMessage>
        </FormControl>
      )}
    </Field>
  );
};
